@if (isEditing()) {
  <div class="edit-wrapper" (click)="$event.stopPropagation()">
    <input
      #inputRef
      matInput
      type="text"
      class="edit-input"
      [placeholder]="placeholder()"
      [value]="draft()"
      [matAutocomplete]="autocomplete"
      (input)="onInput($event)"
      (keydown.escape)="$event.stopPropagation(); cancelEdit()"
      (keydown.enter)="$event.stopPropagation(); submitAfterAutocompleteSelection()"
    />
    <mat-autocomplete #autocomplete="matAutocomplete" (optionSelected)="onOptionSelected($event)">
      @for (option of filteredOptions(); track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-autocomplete>
    <div class="edit-actions tiny-icon-button-wrapper">
      <button
        mat-icon-button
        type="button"
        aria-label="Submit"
        matTooltip="Submit"
        (click)="submit()"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        aria-label="Cancel"
        matTooltip="Discard changes"
        (click)="cancelEdit()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
} @else {
  <div class="display-wrapper">
    @if (isEmpty()) {
      <span class="empty-symbol">{{ emptySymbol() }}</span>
    } @else {
      <span class="value" [matTooltip]="isTrimmed() ? value() : ''">{{ displayValue() }}</span>
    }
    @if (editable()) {
      <span class="tiny-icon-button-wrapper edit-button">
        <button
          mat-icon-button
          type="button"
          aria-label="Edit"
          matTooltip="Edit"
          (click)="$event.stopPropagation(); startEdit()"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </span>
    }
  </div>
}
